import React from "react";

const MessageIcon = ({ color = "#0A61F5" }) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.1395 6.84338L9.99993 11.3634L3.86035 6.84338"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.4583 4.96204H3.54167C2.62119 4.96204 1.875 5.70823 1.875 6.6287V14.3712C1.875 15.2917 2.62119 16.0379 3.54167 16.0379H16.4583C17.3788 16.0379 18.125 15.2917 18.125 14.3712V6.6287C18.125 5.70823 17.3788 4.96204 16.4583 4.96204Z"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default MessageIcon;
